import React, { useEffect, useState } from 'react';
import AppLogo from "../resources/talenvo-png.png";
import christmasLogo from "../resources/talenvo_black.png";


const UseDynamicLogo = () => {
    const [logo, setLogo] = useState<string>(AppLogo);  
    useEffect(() => {
        const today = new Date();
        const month = today.getMonth();  // 0 = January, 11 = December
        const day = today.getDate();

        // THis display
        if ((month === 11 && day >= 1) || (month === 0 && day <= 4)) {
            setLogo(christmasLogo);
        } else {
            setLogo(AppLogo);
        }

    }, []);
    return logo;
}

export default UseDynamicLogo;